import React, { Fragment } from "react";
import "./SoftwareSkill.css";
import { Fade } from "react-awesome-reveal";
import { Icon } from "@iconify/react";

function SoftwareSkill(props: any) {
  const { logos } = props;
  return (
    <div className="d-flex justify-content-center flex-wrap mb-2">
      {logos.map(
        (
          skill: { skillName: string; fontAwesomeClassname: any },
          i: React.Key | null | undefined
        ) => {
          return (
            <Fragment key={i}>
              <div
                className="icon icon-lg icon-shape shadow-sm rounded-circle m-1"
                id={skill.skillName.replace(/\s/g, "")}
              >
                <Icon
                  icon={skill.fontAwesomeClassname}
                  data-inline="false"
                ></Icon>
              </div>
         
            </Fragment>
          );
        }
      )}
    </div>
  );
}

export default SoftwareSkill;
